import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from './EmojiRating.module.scss';

export interface EmojiRatingProps {
  name: string;
  selectedRating: (selectedRating: string) => void;
}

const EmojiRating: React.FC<EmojiRatingProps> = ({name, selectedRating}) => {
  const handleSelectedRating = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target;
    selectedRating(value);
  };

  return (
    <div className={styles.rating} role="radiogroup">
      <input
        className={styles.hiddenInput}
        type="radio"
        name={name}
        id={`${name}_5`}
        value={5}
        onChange={handleSelectedRating}
      />
      <label
        className={`${styles.emoji} ${styles.emojiHearts}`}
        htmlFor={`${name}_5`}
        aria-label="Péssima"
      >
        <FontAwesomeIcon icon="grin-hearts" size="3x" />
      </label>
      <input
        className={styles.hiddenInput}
        type="radio"
        name={name}
        id={`${name}_4`}
        value={4}
        aria-label="4"
        onChange={handleSelectedRating}
      />
      <label className={styles.emoji} htmlFor={`${name}_4`} aria-label="Ruim">
        <FontAwesomeIcon icon="smile" size="3x" />
      </label>
      <input
        className={styles.hiddenInput}
        type="radio"
        name={name}
        id={`${name}_3`}
        value={3}
        onChange={handleSelectedRating}
      />
      <label className={styles.emoji} htmlFor={`${name}_3`} aria-label="Neutra">
        <FontAwesomeIcon icon="meh" size="3x" />
      </label>
      <input
        className={styles.hiddenInput}
        type="radio"
        name={name}
        id={`${name}_2`}
        value={2}
        onChange={handleSelectedRating}
      />
      <label className={styles.emoji} htmlFor={`${name}_2`} aria-label="Boa">
        <FontAwesomeIcon icon="frown" size="3x" />
      </label>
      <input
        className={styles.hiddenInput}
        type="radio"
        name={name}
        id={`${name}_1`}
        value={1}
        onChange={handleSelectedRating}
      />
      <label className={styles.emoji} htmlFor={`${name}_1`} aria-label="Ótima">
        <FontAwesomeIcon icon="angry" size="3x" />
      </label>

      <div className={styles.ratingDescription}>
        <span className={styles.ratingLabel}>Péssima</span>
        <span className={styles.ratingLabel}>Ótima</span>
      </div>
    </div>
  );
};

export default EmojiRating;
